import React, { useState } from 'react'
import { Button, Form, Modal, ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap'
import { Store } from '../App';
import { useContext } from 'react';
import { candidateHelpMessage } from '../Service/LoginService';
import { loadPopup,loadSuccessPopup } from '../Utils/LoginUtils';
export const HelpModelComponent = ({ handleHelpClose, handleHelpShow, show, setShow }) => {
  const [email, setEmail] = useState('rustam@voicera-analytics.in');
  const [description, setDescription] = useState('');
  const { data } = useContext(Store);
  const assessmentId = data !== null ? data?.assessmentId : "";
  const candidateEmail = data !== null ? data?.email : "";
  
  const isEmailValid = () => {
    return (email && email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g));
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  }
  const handleDescChange = (event) => {
    setDescription(event.target.value);
  }

  const handleSubmitHelpRequest = () => {
    const data={
      assessmentId,
      candidateEmail,
      hrEmail:email,
      description
    }
    candidateHelpMessage(data).then((response) => {
      loadSuccessPopup(response.data);
      setDescription('');
    })
    .catch((err) => {
      loadPopup("Unable to send message please try with your mobile");
    });
  
  }

  return (
    <>
      <Modal show={show} onHide={handleHelpClose}
        backdrop="static"
        keyboard={false}
        centered>
        <ModalHeader closeButton className='m-1  ' style={{ backgroundColor: "", color: "" }}>
          <ModalTitle>
            <h1 className='display-5' style={{ "fontSize": "large" }}>Ugh! Please write us your issue</h1>
          </ModalTitle>
        </ModalHeader>
        <ModalBody>
          {candidateEmail===""?<p>Please Email If any issue occurs <br/>Email : <mark>{email}</mark> <br/>or Call:<mark> +918787845876</mark> </p>:
           <>
           <div className="form-floating">
            <input type='email'
              className="form-control mb-3" 
              value={email}
              onChange={handleEmailChange} placeholder="email@example.com" id="email" readOnly />
            <label htmlFor="email">Send Email To</label>
          </div>
         <div className="form-floating">
            <textarea className="form-control" style={{ minHeight: "100px", height: "200px" }} value={description} onChange={handleDescChange} placeholder="Leave a comment here" id="desc"></textarea>
            <label htmlFor="desc">Detailed issue</label>
          </div>
          </>
           }
        </ModalBody>
        <Modal.Footer>
          <Button variant={(!email || !description) ? "btn btn-outline-secondary" : "btn btn-outline-success"}
            disabled={(!email || !description) || !isEmailValid()} onClick={handleSubmitHelpRequest}>
            Submit
          </Button>
          <Button variant="btn btn-outline-danger" onClick={handleHelpClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
